import React from 'react';
import SPASectionHeading from '../../shared/SPASectionHeading';

// AIDEV-NOTE: The legacy page's lesson tags form (admin/tags partial) is not on this page yet — it
// loads every available tag for the program. This holds its place until tags get their own SPA
// treatment.
const LessonTagsPlaceholder = () => (
  <section aria-labelledby="lesson-tags-heading" className="tw-mb-6">
    <SPASectionHeading title="Tags" />
    <p className="tw-m-0 tw-mt-1.5 tw-text-sm tw-text-spa-secondary">
      Standards tags for this lesson will be managed here.
    </p>
  </section>
);

export default LessonTagsPlaceholder;
